import React, { Component } from 'react'
import Store from 'store'
import { Redirect } from 'react-router-dom'
import { Visualize, Viewport, Layer } from '../lib/react-visualize/Core'
import SideBar from './SideBar'
import Button from './Button'
import ColorMenu from './ColorMenu'
import ColorPicker, { getTransformedLabel } from './ColorPicker'
import HandlePicker from './HandlePicker'
import HandleEditor from './HandleEditor'
import Form from './Form'
import { I18n } from 'react-i18next'
import i18n from '../config/i18n'
import regions from '../config/regions.json'
import env from '../config/env.json'
import params from '../config/params.json'
import './Configurator.css'
import backgroundLayer from '../assets/images/background/background.jpg'
import novaeLogo from '../assets/images/novae-black.png'

// Store.remove('customDesigns')

class Configurator extends Component {
  constructor (props) {
    super(props)

    this.loading = false
    this.canvas = {
      width: 1920,
      height: 1200
    }
    this.handles = []

    // Init i18n
    const { region, handle } = props.match.params
    this.region = region

    const { lang, colorSet } = regions
      .find(({ countries }) => countries.find(({ id }) => id === region))
      .countries
      .find(({ id }) => id === region)

    this.handles = require('../config/handles/' + colorSet + '.json')

    i18n.changeLanguage(lang)

    const currentHandle = this.handles.find(h => h.handle === handle)

    this.colorSet = currentHandle.colors

    // this.preloadAssets(handle)

    if (undefined === currentHandle.backgroundFrames[Store.get('backgroundFrame')]) {
      Store.set('backgroundFrame', 0)
    }
    const backgroundFrame = currentHandle.backgroundFrames[Store.get('backgroundFrame')].image_file

    // Init Configurator
    this.state = {
      handle,
      color: this.colorSet[0],
      backgroundFrame,
      handleEditor: false,
      displayForm: false
    }

    this.config = {
      image: null,
      handle,
      type: this.colorSet[0].color_type,
      coords: null,
      canvas: null,
      preview: null,
      data: {
        model: handle,
        color: this.colorSet[0],
        email: null, // Going to be set by the form
        lang: lang
      }
    }

    this.updateHandle = this.updateHandle.bind(this)
    this.updateColorType = this.updateColorType.bind(this)
    this.updateColor = this.updateColor.bind(this)
    this.updateFrame = this.updateFrame.bind(this)
    this.addColors = this.addColors.bind(this)
  }

  componentWillUpdate (props) {
    // Browsing through handles by props (routed updates)
    if (props.match.params.handle !== this.state.handle) {
      this.updateHandle({ value: props.match.params.handle })
    }

    // Updating custom designs if needed
    const customDesigns = Store.get('customDesigns') || []
    customDesigns.forEach(design => {
      if (
        !this.colorSet.find(c => c.ornament === design.key) &&
        design.handle === props.match.params.handle
      ) {
        this.colorSet.push({
          image_file: props.match.params.handle + '/RAL/0011.png',
          color: 'black',
          color_css: '#000',
          color_type: 'custom',
          ornament: design.key,
          ornament_category: null,
          ornament_color: null,
          ornament_css: null,
          css: {
            backgroundColor: '#333',
            backgroundImage: 'url(\'' + design.dataURL + '\')',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          },
          declinable: false,
          customDesign: design.dataURL
        })

        this.colorSet.push({
          image_file: props.match.params.handle + '/RAL/0010.png',
          color: 'white',
          color_css: '#fff',
          color_type: 'custom',
          ornament: design.key,
          ornament_category: null,
          ornament_color: null,
          ornament_css: null,
          css: {
            backgroundColor: '#333',
            backgroundImage: 'url(\'' + design.dataURL + '\')',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          },
          declinable: false,
          customDesign: design.dataURL
        })
      }
    })
  }

  preloadAssets (handle) {
    let visualize = Object.assign({ layers: [] }, Store.get('visualize'))
    // let j

    // Flush handles from store
    visualize.layers = []

    // handle.colors.forEach((c, i) => {
    //   visualize.layers.push({
    //     type: 'img',
    //     id: i,
    //     asset: require('../assets/images/handles/' + c.image_file)
    //   })
    //   j = i
    // })
    // handle.backgroundFrames.forEach((bgf, i) => {
    //   visualize.layers.push({
    //     type: 'img',
    //     id: i + j,
    //     asset: require('../assets/images/handles/' + bgf)
    //   })
    // })

    Store.set('visualize', visualize)
  }

  goBack () {
    this.setState({ goBack: true })
  }

  setLoading (state = true) {
    this.loading = state
  }

  preloadLayers (assets, callback) {
    let counter = 0
    this.setLoading()

    assets.forEach(a => {
      const img = new window.Image()
      img.onload = () => {
        counter++
        if (counter === assets.length) {
          this.setLoading(false)
          callback()
        }
      }
      img.onerror = () => this.setLoading(false)
      img.src = a
    })
  }

  updateHandle (target) {
    const handle = this.handles.find(h => h.handle === target.value)
    const frame = handle.backgroundFrames[Store.get('backgroundFrame')].image_file
    const prevColor = this.state.color

    // Update the color set
    this.colorSet = handle.colors

    const newColor = this.colorSet.find(c => {
      return (
        c.color_type === prevColor.color_type &&
        c.color === prevColor.color &&
        c.ornament === prevColor.ornament &&
        c.ornament_color === prevColor.ornament_color
      )
    }) || handle.colors[0]

    // this.preloadAssets(handle)

    this.preloadLayers(
      [
        require('../assets/images/handles/' + frame),
        require('../assets/images/handles/' + newColor.image_file)
      ],
      () => this.setState({
        handle: target.value,
        color: newColor,
        backgroundFrame: frame
      })
    )
  }

  updateFrame () {
    const frame = this.handles
      .find(h => h.handle === this.state.handle)
      .backgroundFrames[Store.get('backgroundFrame')].image_file

    this.preloadLayers(
      [require('../assets/images/handles/' + frame)],
      () => this.setState({
        backgroundFrame: frame
      })
    )
  }

  updateColorType (event) {
    // Select first available color for this handle
    const defaultColor = this.handles
      .find(h => h.handle === this.state.handle)
      .colors
      .find(c => event.target.value === 'decor' ? c.ornament_color === '13' : c.color_type === event.target.value) || {}
    this.preloadLayers(
      [require('../assets/images/handles/' + defaultColor.image_file)],
      () => this.setState({ color: defaultColor })
    )
  }

  addColors (...args) {
    const colors = this.handles
      .find(h => h.handle === this.state.handle).colors

    args.forEach(color => {
      if (!colors.find(c => {
        return (
          c.customDesign === color.customDesign &&
          c.color === color.color
        )
      })) {
        colors.push(color)
      }

      // lol this condition makes no sens to read but actually makes sense
      // If the base color (black or white) is the current one, set it
      if (this.state.color.color === color.color) {
        this.updateColor({ target: { value: JSON.stringify(color) } })
      }
    })
  }

  updateColor (event) {
    const target = event.currentTarget ? event.currentTarget : event.target
    const color = JSON.parse(target.value)

    this.preloadLayers(
      [require('../assets/images/handles/' + color.image_file)],
      () => this.setState({ color })
    )
  }

  getHandleColors () {
    return this.handles.find(h => h.handle === this.state.handle).colors
  }

  getHandlePropSet (prop) {
    // Fetches a set of unique values in JSON data
    // e.g. prop = color_type returns ['ral', 'anodized', 'decor']
    // for the H48103 handle
    return [...new Set(this.getHandleColors().map(c => c[prop]))]
  }

  buildOrnamentColors () {
    return this.getHandleColors().filter(color => {
      return (
        color.ornament === this.state.color.ornament &&
        color.color === this.state.color.color &&
        color.ornament_color !== null
      )
    }).map(color => Object.assign(color, {
      css: { background: color.ornament_css }
    }))
  }

  displayForm () {
    const customDesigns = Store.get('customDesigns') || []
    const currentCustom = customDesigns
      .find(design => design.key === this.state.color.ornament) ||
      {
        key: null,
        handle: this.state.handle,
        dataURL: null,
        originalFile: '',
        coords: { x: 0, y: 0, w: 0, h: 0, rotation: 0, scale: 1 },
        canvas: { w: 0, h: 0 }
      }

    // Store config as it will be sent to the back-end
    this.config = {
      image: currentCustom.originalFile,
      handle: this.state.handle,
      type: this.state.color.color_type,
      coords: currentCustom.coords,
      canvas: currentCustom.canvas,
      preview: Viewport.renderCanvas(),
      data: {
        model: this.state.handle,
        color: this.state.color,
        email: null, // Going to be set by the form
        lang: i18n.language
      }
    }
    this.setState({ displayForm: true })
  }

  render () {
    // I'll be Back
    if (this.state.goBack === true) {
      return (<Redirect to={'/' + this.region} />)
    }

    const imageFile =
      require('../assets/images/handles/' + this.state.color.image_file)
    const backgroundFrame =
      require('../assets/images/handles/' + this.state.backgroundFrame)

    const colors = this.getHandleColors().filter(c => {
      return c.color_type === this.state.color.color_type
    })

    const ornamentColorPickerClasses = ['configurator-ornament-colors']
    // TODO this is crappy
    // if (this.state.color.declinable || this.state.color.ornament_color !== null) {
    ornamentColorPickerClasses.push('open')
    // }

    // Layers
    const layers = [
      <Layer type='img' asset={backgroundLayer} key='vp-background' />,
      <Layer type='img' asset={backgroundFrame} key='vp-frame' />,
      <Layer type='img' asset={imageFile} key='vp-handle' />
    ]
    if (this.state.color.customDesign) {
      layers.push(
        <Layer type='img' asset={this.state.color.customDesign} key='vp-custom' />
      )
    }

    // Stored config
    const config = this.config.data

    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            {/* <Visualize assetCollection={[backgroundLayer, backgroundFrame, imageFile]}> */}
            <Visualize>
              <Viewport width={this.canvas.width} height={this.canvas.height}>
                {layers}
              </Viewport>
            </Visualize>
            <SideBar>
              <button onClick={this.goBack.bind(this)} className='go-back'>
                <span className='material-icons'>arrow_back</span>
              </button>
              <HandlePicker
                region={this.props.match.params.region}
                handles={this.handles}
                handle={this.state.handle}
                onUpdate={this.updateFrame}
              />
              {/* Color type menu (RAL, Anodized, etc.) */}
              <div className='configurator-button-group'>
                {this.getHandlePropSet('color_type').map(colorType => (
                  <Button
                    key={colorType}
                    className={this.state.color.color_type === colorType && 'active'}
                    onClick={this.updateColorType}
                    value={colorType}
                  >{t('configurator.colorType.' + colorType)}</Button>
                ))}
              </div>
              {/* Actual color squares */}
              <ColorMenu
                colors={colors}
                color={this.state.color}
                onClick={this.updateColor}
                customize={() => this.setState({ handleEditor: true })}
              />
            </SideBar>
            <ColorPicker
              className={ornamentColorPickerClasses.join(' ')}
              activeLayer={this.state.color.image_file}
              colors={this.buildOrnamentColors()}
              color={this.state.color}
              onClick={this.updateColor}
              hideLabel
            />
            <img className='aluk-novae-logo' src={novaeLogo} alt='Novae' />
            <button
              onClick={this.displayForm.bind(this)}
              className='configurator-red-button configurator-sendconfig'
            >
              {t('configurator.sendConfig')}
            </button>
            {
              this.state.displayForm
                ? <Form
                  sendTo={env.apiURL + params.sendEmailRoute}
                  config={this.config}
                  close={() => this.setState({ displayForm: false })}
                >
                  <h1>{t('configurator.form.myConfig')}</h1>
                  <img src={Viewport.renderCanvas()} className='form-preview' alt='' />
                  <div className='configurator-summary'>
                    <p>
                      <span className='label'>{t('configurator.form.model')}</span>
                      <span className='value'>{config.model}</span>
                    </p>

                    <p>
                      <span className='label'>{t('configurator.form.color')}</span>
                      <span className='value'>
                        {
                          config.color.color_type === 'decor' || config.color.color_type === 'custom'
                            ? config.color.color : getTransformedLabel(config.color)
                        }
                      </span>
                    </p>

                    {
                      config.color.ornament !== null
                        ? <p>
                          <span className='label' key='summary-ornament-l'>
                            {t('configurator.form.ornament')}
                          </span>
                          <span className='value' key='summary-ornament-v'>
                            {
                              config.color.color_type !== 'custom'
                                ? config.color.ornament
                                : t('configurator.form.custom')
                            }
                          </span>
                        </p>
                        : null
                    }

                    {
                      config.color.ornament_color !== null
                        ? <p>
                          <span className='label' key='summary-ornament-l'>
                            {t('configurator.form.ornament_color')}
                          </span>
                          <span className='value' key='summary-ornament-v'>
                            {config.color.ornament_color}
                          </span>
                        </p>
                        : null
                    }
                  </div>
                </Form>
                : null
            }
            {
              this.state.handleEditor
                ? <HandleEditor
                  handle={this.state.handle}
                  addColors={this.addColors}
                  perspHandler={env.apiURL + params.perspectiveRoute}
                  close={() => this.setState({ handleEditor: false })}
                />
                : null
            }
          </div>
        )}
      </I18n>
    )
  }
}

export default Configurator



// WEBPACK FOOTER //
// ./src/components/Configurator.js